import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Mental} from "../Mental";
import {TimelineLite} from "gsap";
import {MentalNormalSymbol} from "../reel/symbols/MentalNormalSymbol";

export class MentalPlusOneTextView extends PIXI.Container implements StageLayer {
    private _plusOneTexts: PIXI.BitmapText[] = [];
    private _blastAnimations: TimelineSprite[] = [];

    constructor() {
        super();

        this.initAnimations();
    }

    public playPlusOneTextAnimation(reelId: number, symId: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            plusOneItem: PIXI.BitmapText = this._plusOneTexts[reelId],
            blastItem: TimelineSprite = this._blastAnimations[reelId],
            symHeight: number = 198,
            reelAreaTop: number = (reelId % 2 === 0 ? 90 : (90 + 99));

        tl.add(() => {
            plusOneItem.y = blastItem.y = reelAreaTop + (symId * symHeight) + (symHeight / 2);

            plusOneItem.visible = true;
            plusOneItem.alpha = 1;
        }, 0);

        tl.fromTo(plusOneItem.scale, {x: 4, y: 4}, {x: 0.8, y: 0.8, duration: 0.2});
        tl.add([
            ()=>{blastItem.getAnimationAutoShowHide(true, true)},
            this.doShake(reelId, symId)
        ]);

        tl.to(plusOneItem.scale, {x: 1, y: 1, duration: 0.1}, 0.2);

        tl.to(plusOneItem, {alpha: 0, duration: 2, onComplete: () => {plusOneItem.visible = false}}, 0.3);

        return tl;
    }

    private initAnimations(): void {
        const numItems: number = 5,
            symWidth: number = 144;
        let plusOneText: PIXI.BitmapText,
            blastAnimation: TimelineSprite;

        for (let i: number = 0; i < numItems; i++) {
            plusOneText = new PIXI.BitmapText("+1", {
                fontName: "MultiplierWinCountUp",
                fontSize: 30
            });
            plusOneText.visible = false;
            plusOneText.x = (symWidth * i) + (symWidth / 2);
            plusOneText.pivot.set(plusOneText.width / 2, plusOneText.height / 2);
            this._plusOneTexts.push(plusOneText);

            blastAnimation = new TimelineSprite(Mental.assetLoader.getTextures("multBlast"));
            blastAnimation.hide();
            blastAnimation.x = plusOneText.x;
            blastAnimation.anchor.set(0.5);
            blastAnimation.scale.set(3);
            blastAnimation.blendMode = PIXI.BLEND_MODES.ADD;
            this._blastAnimations.push(blastAnimation);

            this.addChild(plusOneText, blastAnimation);
        }
    }

    private doShake(reelId: number, symId: number): TimelineLite {
        const symbolLayer: PIXI.Container = (Mental.reelArea.getReel(reelId).model.getStopSymbolAt(symId).positionable as MentalNormalSymbol)._symbolLayer,
            duration: number = 0.1,
            tl: TimelineLite = new TimelineLite({
                paused: true,
                onStart: () => {
                    symbolLayer.pivot.set(36, 49.5); // as => 144/4 and 198/4
                    symbolLayer.position.set(symbolLayer.x + 36, symbolLayer.y + 49.5);
                },
                // it needs to execute irrespective of abort, if it doesn't, serious problem.
                onComplete: () => {
                    symbolLayer.scale.set(1);
                    symbolLayer.pivot.set(0);
                    symbolLayer.position.set(0, (symId * 198));
                }
            });

        tl.to(symbolLayer.scale, {x: 1.1, y: 1.1, duration: duration});
        tl.to(symbolLayer.scale, {x: 1, y: 1, duration: duration});
        tl.to(symbolLayer.scale, {x: 1.1, y: 1.1, duration: duration});
        tl.to(symbolLayer.scale, {x: 1, y: 1, duration: duration});

        return tl.play(0);
    }
}